import { render, staticRenderFns } from "./Please.vue?vue&type=template&id=2d5a4d0e&scoped=true"
import script from "./Please.vue?vue&type=script&lang=js"
export * from "./Please.vue?vue&type=script&lang=js"
import style0 from "./Please.vue?vue&type=style&index=0&id=2d5a4d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a4d0e",
  null
  
)

export default component.exports